import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { QUOTES } from "../../data";

export default function Quotes() {
  const [i, setI] = useState(0);
  const q = QUOTES[i];
  const go = (d) => setI((p) => (p + d + QUOTES.length) % QUOTES.length);

  return (
    <section data-testid="quotes-section" className="relative py-24 lg:py-32 bg-ink text-sand overflow-hidden">
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[38rem] h-[38rem] rounded-full blur-[130px] opacity-25"
        style={{ background: "radial-gradient(circle, rgba(217,155,38,0.7), transparent 70%)" }} />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <Quote className="w-10 h-10 text-gold mx-auto mb-8" />
        <div className="min-h-[240px] sm:min-h-[220px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote key={i} data-testid="quote-card-item"
              initial={{ opacity: 0, y: 20, filter: "blur(8px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -20, filter: "blur(8px)" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}>
              <p className="font-quote text-2xl sm:text-3xl lg:text-[2.4rem] leading-[1.35] italic text-sand/95">
                "{q.text}"
              </p>
              <footer className="mt-8">
                <div className="font-display text-lg tracking-[0.15em] text-gold">{q.author}</div>
                <div className="text-sm text-sand/50 mt-1">{q.source}</div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="mt-10 flex items-center justify-center gap-4">
          <button data-testid="quote-prev-button" onClick={() => go(-1)} className="w-11 h-11 rounded-full border border-sand/25 flex items-center justify-center hover:border-gold hover:text-gold transition-colors">
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div className="flex gap-2">
            {QUOTES.map((_, k) => (
              <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? "w-7 bg-gold" : "w-1.5 bg-sand/30"}`} />
            ))}
          </div>
          <button data-testid="quote-next-button" onClick={() => go(1)} className="w-11 h-11 rounded-full border border-sand/25 flex items-center justify-center hover:border-gold hover:text-gold transition-colors">
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
